@file:OptIn(InternalResourceApi::class)

package realrate.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/realrate.shared.generated.resources/"

@delegate:ResourceContentHash(1_790_391_604)
internal val Res.drawable.add: DrawableResource by lazy {
      DrawableResource("drawable:add", setOf(
        ResourceItem(setOf(), "${MD}drawable/add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_560_254_914)
internal val Res.drawable.calculate: DrawableResource by lazy {
      DrawableResource("drawable:calculate", setOf(
        ResourceItem(setOf(), "${MD}drawable/calculate.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-937_416_963)
internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_867_731_429)
internal val Res.drawable.remove: DrawableResource by lazy {
      DrawableResource("drawable:remove", setOf(
        ResourceItem(setOf(), "${MD}drawable/remove.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("add", Res.drawable.add)
  map.put("calculate", Res.drawable.calculate)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("logo", Res.drawable.logo)
  map.put("remove", Res.drawable.remove)
}
